export const TOUR_EVENT = {
  SNOOZED: "Snoozed",
  CLOSED: "Closed",
  SKIPPED: "Skipped",
  COMPLETED: "Completed",
  HELP_BEACON_SEEN: "HelpBeaconSeen",
} as const;

export const TOUR_STORAGE_PREFIX = "tour:";

export const TOUR_PARAM = "tour";

export const TOUR_STEP_PARAM = "tourStep";

export const TOUR_HELP_TARGET = "help";

export const TOUR_DISMISSAL = {
  HOME_CARD: "home-card-dismissed",
  BANNER: "banner-dismissed",
} as const;

export const TOUR_Z_INDEX = 100;

export const TOUR_SPOTLIGHT_PADDING_PX = 6;

export const TOUR_SPOTLIGHT_RADIUS_PX = 10;
